import React, { useState } from 'react';
import { Container, Row } from 'react-bootstrap';
import Category from '../components/Category';
import ProjectsVideo from '../components/ProjectsVideo';
import BackArrow from '../components/BackArrow';

import '../css/projects.css';

import musicVideos1 from '../img/music-videos/jamie-sparker-music-videos.png';

function MusicVideos() {
  const [popupOn, setPopupOn] = useState(false);
  const [url, setUrl] = useState('');
  const [videoTitle, setVideoTitle] = useState('');
  const [description, setDescription] = useState('');

  return (
    <Container id='projects'>
      <BackArrow lastPage='/projects' />
      <Row className='projects-row'>
        <Category
          photo={musicVideos1}
          title={`#1`}
          overlay={'0.3'}
          routable={false}
          popup={true}
          hover={true}
          setPopupOn={setPopupOn}
          video={true}
          url='https://www.youtube.com/embed/ZRR-IdbmS5s'
          videoTitle='Kygo ft. Justin Jesso - Stargazing'
          description={`We want to remind the world that every human being is unique. Thomas Jefferson once said: "If you want something you have never had, you must be willing to do something you have never done." He was right. No matter who you are, no matter where you come from or what people think about your appearance, you should always believe in yourself and follow your dreams. Stop looking at what other people have and you don´t. Be different and show it....`}
          setUrl={setUrl}
          setVideoTitle={setVideoTitle}
          setDescription={setDescription}
        />
        <ProjectsVideo
          video={true}
          videoTitle={videoTitle}
          description={description}
          url={url}
          popupOn={popupOn}
          setPopupOn={setPopupOn}
        />
      </Row>
    </Container>
  );
}

export default MusicVideos;
